import DgTable from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTable.install = function (Vue) {
  Vue.component(DgTable.name, DgTable)
}
export default DgTable

export { DgTable }
